import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, inject, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, ModalComponent, ModalFooterDirective, SelectComponent } from 'mbs-ui-kit';
import { Edition } from 'mbs-ui-shared@models/Computer';
import { ComputersAbstractService } from 'mbs-ui-shared@services/computers.service';
import { catchError, Observable, of, take, tap } from 'rxjs';

@Component({
  selector: 'mbs-manage-license-computer-modal',
  templateUrl: './manage-license-computer-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonComponent, I18NextPipe, ModalComponent, SelectComponent, ModalFooterDirective]
})
export class ManageComputerModalComponent implements AfterViewInit {
  private computersService = inject(ComputersAbstractService);

  public loading = false;
  public selectedLicenseType;
  public isAvailableLicensesLoading = true;
  public licensesTypes: Observable<Edition[]> = of(null);

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  manage(): void {
    this.loading = true;

    this.computersService
      .updateBackupAgentSettings(this.baseModal.data.endpointId, { mbsBuildType: this.selectedLicenseType })
      .pipe(
        take(1),
        catchError(() => {
          this.loading = false;
          return of(false);
        })
      )
      .subscribe(() => {
        this.baseModal.save();
        this.loading = false;
      });
  }

  ngAfterViewInit(): void {
    this.setLicensesTypes();
  }

  setLicensesTypes() {
    this.isAvailableLicensesLoading = true;
    this.licensesTypes = this.computersService.getAvailableEditions(this.baseModal.data.endpointId).pipe(
      take(1),
      catchError(() => of(null)),
      tap((editions) => {
        this.selectedLicenseType = editions?.find((edition) => edition.isCurrentBuild).buildValue;
        this.isAvailableLicensesLoading = false;
      })
    );
  }
}
